const o = "form_u8stT", s = {
  form: o
};
export {
  s as default,
  o as form
};
//# sourceMappingURL=landingForm.module.scss.js.map
